import { RootState } from '../store/configureStore';

export const getThankyou = (state: RootState) => state?.thankyou?.thankyou;

export const isFetchingThankyou = (state: RootState) =>
  state?.thankyou?.isFetchingThankyou;

export const didFetchingThankyouFailed = (state: RootState) =>
  state?.thankyou?.fetchingThankyouFailed;
